// extracted by mini-css-extract-plugin
export default {"toolsPanel":"KizViewPlugin_toolsPanel__H2bEU"};